<template>
    <div>
        <vapp-header btnBack ></vapp-header>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <!--<div class="add-customer">-->
                    <!--<b-link to="/create_business">-->
                    <!--<img src="@/assets/images/ic_add_customer.svg">-->
                    <!--<span>Add New Business</span>-->
                    <!--</b-link>-->
                    <!--</div>-->
                    <!--<label>Contacts</label>-->
                    <ul class="customer-list">
                        <li v-for="(contact, index) in contacts" :key="index" @click="selectContact(contact)">
                            <div class="contact-circle">
                                <span>{{ contact.name.charAt(0) }}</span>
                            </div>
                            <span>{{ contact.name }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!--<vapp-right-panel></vapp-right-panel>-->
    </div>
</template>

<script>
    import { mapState, mapActions} from 'vuex';
    import contactSvc from '../../services/contactService'
    export default {
        name: "SelectContactFromList",
        data: () => ({
            contacts: []
        }),
        computed : {
            ...mapState('company',['selectedCompany'])
        },
        methods: {
            ...mapActions('invoice',['setCreateInvoiceObj', 'setEditInvoiceObj']),
            selectContact(contact) {
                this.setCreateInvoiceObj({ contact: contact});
                this.setEditInvoiceObj({
                    contact_name: contact.display_name,
                    contact_id: contact.id
                });
                this.$router.go(-1);
            }
        },
        mounted() {
            console.log("Mounted : Select Contact From List");
            contactSvc.methods.getContacts(this.selectedCompany)
                .then(data => {
                    this.contacts = data.contacts;
                })
        },
    }
</script>

<style scoped>
    .add-customer {
        cursor: pointer;
        padding: 25px 25px 25px 0;
    }

    .add-customer a {
        text-decoration: none;
    }

    .add-customer a {
        text-decoration: none;
    }

    .add-customer img {
        width: 28px;
        margin-right: 11px;
    }

    .add-customer span {
        font-weight: 500;
        color: #05d2c5;
    }

    .customer-list {
        padding-left:0;
        margin-bottom: 0;
    }

    .customer-list li {
        cursor: pointer;
        list-style: none;
        padding: 15px 15px 15px 0;
        transition: all 0.3 ease-in-out;
    }

    .customer-list>li>span {
        transition: all 0.3s ease-in-out;
    }

    .customer-list>li>.contact-circle {
        background: #24cab7;
        border-radius: 50%;
        border: 1px solid rgba(0,0,0,0.1);
        margin-right: 15px;
        display: inline-block;
        width: 50px;
        height: 50px;
        text-align: center;
    }

    .customer-list>li>.contact-circle>span {
        color: white;
        text-transform: lowercase;
        line-height: 43px;
        font-size: 1.25rem;
    }

    .customer-list li img {
        width: 15px;
    }
</style>
